import { FormControl } from '@angular/forms';
import { DateUtils } from './date-utils';

export class CustomValidators {

  static INTEGER_REGEXP: RegExp = new RegExp('^(0|[1-9][0-9]*)$');
  static DECIMAL_REGEXP: RegExp = new RegExp('^(0|[1-9][0-9]*)(\\,[0-9]{1,2})?$');
  static PHONE_REGEXP: RegExp = new RegExp('^0[0-9]{9}$');
  static INT_PHONE_REGEXP: RegExp = new RegExp('^(([+][(]?[0-9]{1,3}[)]?)|([(]?[0-9]{3,4}[)]?))\\s*[)]?[-\\s\.]?[(]?[0-9]{1,3}[)]?([-\\s\.]?[0-9]{2,3})([-\\s\.]?[0-9]{2,4})([-\\s\.]?[0-9]{2,4})$');

  static integer(c: FormControl) {
    var value = c.value;
    if (value === '' || value === null || typeof value === 'number') return null;
    value = value.replace(/\s/g, '');
    return value === '' || value === null || CustomValidators.INTEGER_REGEXP.test(value) ? null : { integer: false };
  }

  static supzero(c: FormControl) {
    return c.value === '' || c.value === null || (c.value > 0) ? null : { supzero: false };
  }

  static decimal(c: FormControl) {
    return c.value === '' || c.value === null || CustomValidators.DECIMAL_REGEXP.test(c.value) ? null : { decimal: false };
  }

  static date(c: FormControl) {
    return c.value === '' || c.value === null || DateUtils.stringToDate(c.value) != null ? null : { date: false };
  }

  static phone(c: FormControl) {
    return c.value === '' || c.value === null || CustomValidators.INT_PHONE_REGEXP.test(c.value) ? null : { phone: false };
  }

  static minYear2008(c: FormControl) {
    const date: Date = DateUtils.stringToDate(c.value);
    if (c.value === '' || c.value === null || date === null) {
      return null;
    }
    return (date.getFullYear() >= 2008) ? null : { minYear2008: false };
  }

  static beforeToday(c: FormControl) {
    const date: Date = DateUtils.stringToDate(c.value);
    if (c.value === '' || c.value === null || date === null) {
      return null;
    }
    const today: Date = new Date();
    return (date < today) ? null : { beforeToday: false };
  }

  static afterTodayPlus14(c: FormControl) {
    const date: Date = DateUtils.stringToDate(c.value);
    if (c.value === '' || c.value === null || date === null) {
      return null;
    }
    const todayPlus14: Date = new Date();
    todayPlus14.setDate(todayPlus14.getDate() + 14);
    return (date > todayPlus14) ? null : { afterTodayPlus14: false };
  }

  static afterToday(c: FormControl) {
    const date: Date = DateUtils.stringToDate(c.value);
    if (c.value === '' || c.value === null || date === null) {
      return null;
    }
    let today: Date = new Date();
    let m = today.getMonth()+1;
    today = DateUtils.stringToDate((m > 9 ? '' : '0') + m + "/" + today.getFullYear());
    return (date >= today) ? null : { afterToday: false };
  }

  static true(c: FormControl) {
    return c.value === true ? null : { true: false };
  }

  static min22000(c: FormControl) {
    var value = c.value;
    if (value === '' || value === null) return null;
    const num = parseInt(value, 10);
    if (isNaN(num)) {
      return null;
    }
    return num >= 22000 ? null : { min22000: false };
  }

  static min50000(c: FormControl) {
    var value = c.value;
    if (value === '' || value === null) return null;
    const num = parseInt(value, 10);
    if (isNaN(num)) {
      return null;
    }
    return num >= 50000 ? null : { min50000: false };
  }

  static min18years(c: FormControl) {
    const birthDate: Date = DateUtils.stringToDate(c.value);
    if (c.value === '' || c.value === null || birthDate === null) {
      return null;
    }
    return (DateUtils.getAge(birthDate) >= 18) ? null : { min18years: false };
  }

}



// WEBPACK FOOTER //
// ./src/app/custom-validators.ts